import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, showlist, StateApi, stateRequest, updateReq, WebUrl } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import "react-datepicker/dist/react-datepicker.css";
export default class MotherhoodWallModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      page: 1,
      response: null,
      status: "Active",
      motherid: "",
      loadMoreDisplay: false,
    };
    this.update = this.update.bind(this);
    this.showPost = this.showPost.bind(this);
  }
  componentDidMount() {
    var ref = this;
    var mstatus = this.props.match.params.status;
    if(mstatus == 'disabled') {
        mstatus = 0;
    } else {
        mstatus = 1;
    }
    ref.setState({
        page: 1
    },() => {
        this.showPost(mstatus);
    });
  }
  componentWillReceiveProps(nextProps) {
    var ref = this;
    var mstatus = nextProps.match.params.status;
    if(mstatus == 'disabled') {
        mstatus = 0;
    } else {
        mstatus = 1;
    }
    ref.setState({
        page: 1
    },() => {
        this.showPost(mstatus);
    });
        
  }

  filterid = (id) => {
    if(!id){
        alert('Please Enter ID');
        return false;
    }
    this.showPost(1, "", id);
  }

  showPost = async (mstatus, loadmore, id) => {
    var ref = this;
    if (!loadmore) {
        ref.setState({ items: [] });
      }  
      let callPage = 1;
      if (!loadmore) {
        ref.setState({page: 1});
      }
      
      callPage = this.state.page ? this.state.page : 1;
      if(id) {
        callPage = 1;
      }
    let reqData = {
      data: {},
      method: "GET",
      action: `motherhood/list?limit=100&sort=desc&page=${callPage}&status=${mstatus}&id=${this.state.motherid}`,
    };
    var response = await showlist(reqData);
    if (
        response &&
        (response.resultFlag === 1 || response.resultFlag === "1")
      ) {
        ref.setState({postCount: response.count})
        if (response.response.length > 99) {
            var pages = this.state.page + 1;
          ref.setState({
                page: pages,
              loadMoreDisplay: true,
            });
        } else {
            ref.setState({
                loadMoreDisplay: false,
              });
        }
        let data = [];        
          if (loadmore) {
            let result = [...this.state.items, ...response.response];
            ref.setState({
                items: result
              })
        } else {
            data = response.response;
            ref.setState({
              items: data
            })
        }
      }
  }
  loadMoreData = () => {
    var mstatus = this.props.match.params.status;
    if(mstatus == 'disabled') {
        mstatus = 0;
    } else {
        mstatus = 1;
    }
      this.showPost(mstatus, "loadmore");
  };

  update = async (id, mstatus) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    var raw = JSON.stringify({
      "id": id,
      "status": mstatus
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(WebUrl + "/motherhood/update", requestOptions)
      .then(response => response.json())
      .then(response => {
        if (response.resultFlag && response.resultFlag == 1) {
            $("#post_" + id).hide();
          }
      })
      .catch(error => console.log('error', error));

  }
 
  loadSubmitDate = () => {
    this.setState({ lastEvaluatedKey: null }, () => {
      this.submitDate();
    });
  };

  render() {
    var bread = "motherhoodwall / Moderation (Active Posts)";
    var pagelink = "/motherhoodwall/moderation";
    if (this.props.match.params.status == 0) {
      bread = "motherhoodwall/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else {
      pagelink += "/enabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/motherhoodwall/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/motherhoodwall/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    return (
      <div>
        <PageTitle
          title="#MotherhoodWall"
          bread={bread}
          links={links}
          Count={this.state.postCount}
          counttype={
            this.state.status == 1
              ? "Active "
              : this.state.status == 0
              ? "Inactive "
              : ""
          }
        />
        <div className="wrapper wrapper-content">
            {this.props.match.params.status !== "disabled" &&
            <div className="row row_date_div">
            <div className="col-md-2">            
              <input
                id="motherid"
                className="form-control"
                type={"text"}
                defaultValue={this.state.motherid}
                onChange={(e) => this.setState({ motherid: e.target.value })}
              />
            </div>
            <div className="col-md-2">
              <button
                onClick={() => this.filterid(this.state.motherid)}
                className="btn btn-primary"
              >
                Submit
              </button>
            </div>
            <div className="col-md-2">
            <button
                className="btn btn-success"
                style={{
                  marginLeft: "-79px"
                }}
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
            </div>
          </div>
            }
            <br />
            
          {items.length === 0 && (
            <p
              id="nodatafound"
              style={{
                // display: "none",
                textAlign: "center",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "20px",
              }}
            >
              No Data Found
            </p>
          )}
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <img
                                  alt="image"
                                  class="img-responsive"
                                  src={value.canvas_image}
                                />
                                <div className="image_caption">
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.update(
                                        value.id,
                                        "0"
                                      );
                                    }}
                                    type="button"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              <small>
                                Added: {value.created_at ? value.created_at : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/MotherhoodWall/Moderation.jsx